// extracted by mini-css-extract-plugin
export default {"booking-card":"ServiceProviderDashboard_booking-card__7Np0J","booking-info":"ServiceProviderDashboard_booking-info__UuiVp"};